import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';
import { initErrorLogger } from './lib/errorLogger';
import { ErrorBoundary } from './components/ErrorBoundary';

// Initialize global error capture BEFORE React mounts so even errors during
// React initialization are captured. window.error / unhandledrejection /
// fetch-failure handlers funnel into admin_errors via supabaseProto. The
// logger is defensive — it never throws — so wiring it first won't break
// the app even if Supabase is misconfigured.
initErrorLogger();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary boundaryName="root">
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorBoundary>,
);
